import {
  SEARCHLIGHT_CONFIRM_MODAL_OPEN,
  SEARCHLIGHT_CONFIRM_MODAL_CLOSE,
  SEARCHLIGHT_SUBMIT_SUCCESS
} from '@actions/types'

const initialState = {
  action: null,
  showSearchlightConfirmationModal: false
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case SEARCHLIGHT_SUBMIT_SUCCESS:
  case SEARCHLIGHT_CONFIRM_MODAL_CLOSE:
    return {
      ...state,
      showSearchlightConfirmationModal: false,
      action: null
    }
  case SEARCHLIGHT_CONFIRM_MODAL_OPEN:
    return {
      ...state,
      showSearchlightConfirmationModal: true,
      action: payload
    }
  default:
    return state
  }
}

export default reducer
